export const REFERRAL_LINK_REGEX =
  /^https:\/\/bettermode\.cello\.so\/([0-9a-zA-Z-_.]*)$/
